import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { T4DatatableWidget, FindLocationDialog, CreateServiceRequestDialog } from '../../../../t4common/';
import { PageBase, LocationInfo, RentalObjectInfo, DeviceType } from 't4core';
import { T4_EditObjectDialog } from '../../dialogs/EditObjectDialog/editObjectDialog';




@Component({
    selector: 'oneway',
    styleUrls: ['./oneway.component.css'],
    templateUrl: './oneway.component.html',
})
export class OneWayFleetComponent extends PageBase {
    @ViewChild(T4DatatableWidget, {static: false}) datatable: T4DatatableWidget;

    public isAdmin: boolean = false;

    constructor(el: ElementRef, private changeDetectorRef: ChangeDetectorRef) {
        super(el, "FleetManagement");
        if (this.Settings.isInAny(['OneWayAdmin'])) this.isAdmin = true;
    }

    public async openTrailer(item: RentalObjectInfo) {
        if (!this.Settings.isInAny(["OneWayAdmin"])) return;

        await this.Dialog.open(T4_EditObjectDialog, { data: item.Id });
    }

    public async newTrailer() {
        await this.Dialog.open(T4_EditObjectDialog, {} );
    }

    public async delete(item: RentalObjectInfo) {
        var x = await this.UI.confirm("Turbo.FleetManager.EditObjectDialog.headConfirmDelete", "Really? Delete this?", "Turbo.FleetManager.EditObjectDialog.msgConfirmDelete", 'Are you sure that you want to delete {0} ({1})? Make sure that it it sold.', null, [item.Title, item.Alias]);
        if (x) {
            await this.Api.post<any>("RentalObject/RelieveOneWayObject", null, { obj: item.Id });


        }

    }

    public async reenable(item: RentalObjectInfo) {
        var x = await this.UI.confirm("Turbo.FleetManager.EditObjectDialog.headConfirmReenable", "Re-enable object", "Turbo.FleetManager.EditObjectDialog.msgConfirmReenable", 'You are about to enable an object with active issues. Make sure that the issues are resolved. (Brenderup will close the issue)');
        if (x) {
          var token = this.UI.beginLoading('Turbo.FleetManager.EditObjectDialog.msgUpdatingObject', 'Updating Rental Objects', null);
          await this.Api.get<any>("RentalObject/Enable", { objectId: item.Id });
          this.datatable.update();
          this.changeDetectorRef.detectChanges();
          this.UI.loaderCompleted(token);
        }
    }

    public async registerIssue(item: RentalObjectInfo) {
      var res = await CreateServiceRequestDialog.open(this.Dialog, item.Id, item.RentalLocation.Id, item);
      if (!res) return;
      var x = await this.Api.post<any>("Rental/HasRentalAndSimilarObject", null, { rentalObjectId: item.Id, rentalLocationId: item.RentalLocation.Id, rentalObjectTypeId: item.Type.Id });
      if (x) {
        this.UI.alert("Turbo.FleetManager.OneWayFleet.hasRentalAndNoSimilarHeadline", "Has Booking and No Similar trailers", "Turbo.FleetManager.OneWayFleet.hasRentalAndNoSimilar", 'The trailer has been booked with Booking Number:' + x + ' and no similar trailers are available' );
      }
    }

    private lastRelocatLocation: LocationInfo = null;
    public async relocate(item: RentalObjectInfo, byTruck: boolean, createManualBooking: boolean = false) {
        var paramLocation = this.lastRelocatLocation;
        if (!paramLocation) paramLocation = item.RentalLocation;

        var location = await FindLocationDialog.open(this.Dialog, false, false, [], paramLocation);
        if (!location) return;

      try {
        await this.Api.post<any>("RentalObject/RelocateObject", null, { obj: item.Id, loc: location.Id, isCorrection: !byTruck, manualBooking: createManualBooking });
        this.lastRelocatLocation = location;
        item.RentalLocation = location;
        this.UI.snackBar("Transfer complete");
      } catch (ex) {
        console.log(ex);
        this.UI.alert("Turbo.FleetManager.OneWayFleet.headRelocationFailed", "Something went wrong", "Turbo.FleetManager.OneWayFleet.msgRelocationFailed", 'Please get your shit together and try again.');
      }

      this.datatable.clearSelection();
  }

  public async transferTrailers() {
    // Select location
    var location = await FindLocationDialog.open(this.Dialog, false, false, [], this.lastRelocatLocation);
    if (!location) return;
    this.lastRelocatLocation = location;

    for (var i of this.datatable.selectedRows) {
      try {
        await this.Api.post<any>("RentalObject/RelocateObject", null, { obj: i.Id, loc: location.Id, isCorrection: false, manualBooking: false });
        
        i.RentalLocation = location;
      } catch (ex) {
        console.log(ex);
        this.UI.alert("Turbo.FleetManager.OneWayFleet.headRelocationFailed", "Something went wrong", "Turbo.FleetManager.OneWayFleet.msgRelocationFailed", 'Please get your shit together and try again.');
      }
    }

    this.UI.snackBar("Transfer complete");
  }
}
